import script from "./contactUs.vue?vue&type=script&lang=ts&setup=true"
export * from "./contactUs.vue?vue&type=script&lang=ts&setup=true"

import "./contactUs.vue?vue&type=style&index=0&id=63187bbe&lang=scss&scoped=true"

import exportComponent from "D:\\yuntian\\eso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63187bbe"]])

export default __exports__